module.exports = __webpack_public_path__ + "img/loginLogo.91bd5635.png";